import { useCallback } from 'react';
import { Box, Button, Grid, Group, Space, Text, CopyButton, TextInput, Tooltip, useMantineTheme } from '@mantine/core';
import { Copy, Check } from 'tabler-icons-react';
import { CustomColors } from '@root/Design/Themes';

export function ApiAccessKeyCreatedModal(props: { rawKey: string; rawSecret: string; onClose: () => void }) {
    const cancel = useCallback(() => props.onClose(), [props.onClose]);
    const theme = useMantineTheme();

    return (
        <>
            <Box p="m">
                <Text size="sm">Please copy and save your Secret Key, you will not be able to access it again!</Text>
                <Space h="md" />
                <Grid style={{ alignItems: 'end' }}>
                    <Grid.Col span={10}>
                        <TextInput label="API Key" value={props.rawKey} />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <CopyButton value={props.rawKey}>
                            {({ copied, copy }) => (
                                <Tooltip withinPortal withArrow position="bottom" label={copied ? 'Copied' : 'Copy API Key'}>
                                    <Button variant="subtle" onClick={copy}>
                                        {copied ? <Check size={20} /> : <Copy size={20} />}
                                    </Button>
                                </Tooltip>
                            )}
                        </CopyButton>
                    </Grid.Col>
                </Grid>
                <Space h="md" />
                <Grid style={{ alignItems: 'end' }}>
                    <Grid.Col span={10}>
                        <TextInput label="Secret Key" value={props.rawSecret} />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <CopyButton value={props.rawSecret}>
                            {({ copied, copy }) => (
                                <Tooltip withinPortal withArrow position="bottom" label={copied ? 'Copied' : 'Copy Secret Key'}>
                                    <Button variant="subtle" onClick={copy}>
                                        {copied ? <Check size={20} /> : <Copy size={20} />}
                                    </Button>
                                </Tooltip>
                            )}
                        </CopyButton>
                    </Grid.Col>
                </Grid>
                <Space h="md" />
                <Group position="right">
                    <Button data-atid="SettingsCloseButton" onClick={cancel} variant="outline">
                        Close
                    </Button>
                </Group>
            </Box>
        </>
    );
}
